import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const loader = () =>
  import(/* webpackChunkName: "4-feat-share-draft-from-publisher-dialog-host" */ './ShareDraftFromPublisherDialogHost');

export const LoadableShareDraftFromPublisherDialogHost: ComponentType = lazyLoadOnRender({
  loader,
});
